import React from 'react'
import img1 from '../Assets/img1.jpg'
import img2 from '../Assets/img2.png'
import { Link } from 'react-router-dom'
function Home() {
  return (
      <>
 <div class="relative bg-gradient-to-r from-black to-[#e710ea] h-[500px] text-white overflow-hidden">
  <div class="absolute inset-0">
    {/* <img src="https://images.unsplash.com/photo-1522252234503-e356532cafd5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NzEyNjZ8MHwxfHNlYXJjaHw2fHxjb2RlfGVufDB8MHx8fDE2OTQwOTg0MTZ8MA&ixlib=rb-4.0.3&q=80&w=1080" alt="Background" class="object-cover object-center w-full h-[800px]" /> */}
    <div class="absolute inset-0 bg-black opacity-50 "></div>
  </div>
  
  <div class="relative z-10 flex flex-col justify-center items-center h-full text-center">
    <h1 class="text-5xl leading-tight mb-4 font-[Bell-MT]">Transform Your Business with Innovative Web Solution & SMS Services</h1>
    <p class="text-lg text-gray-300 mb-8">Boost your online presence and reach more customers!</p>
    <div class="flex items-center gap-2">
  
  <a
    href="https://bulksmsnagpur.co.in"
    target="_blank"
    rel="noopener noreferrer"
    class="hover:bg-clip-text hover:text-transparent bg-gradient-to-br from-black to-[#e710ea] border-solid border-2 border-white font-bold text-white px-5 py-2 rounded-full text-center"
  >
    View
  </a>
  
  <ion-icon
    name="menu"
    onclick="onMenuToggle(this)"
    class="text-[30px] cursor-pointer md:hidden"
  ></ion-icon>
  </div>
 </div>
</div>
 
  <section class="py-3 py-md-5">
  <div class="container">
    <div class="row gy-3 gy-md-4 gy-lg-0 align-items-lg-center">
      <div class="col-12 col-lg-5">
        <img class="img-fluid rounded" loading="lazy" src={img1} alt="About 2"/>
      </div>
      <div class="col-12 col-lg-7">
        <div class="row justify-content-xl-center">
          <div class="col-12 col-xl-10">
            <h2 class="mb-3">Why Choose Us?</h2>
            <p class="lead fs-4 mb-3 mb-xl-5">With more than 14 years of experience, we provide high-quality SMS services & Website Designing with cost-effective solutions tailored to our clients' needs.</p>
            <div class="d-flex align-items-center mb-3">
              <div class="me-3 text-[#e710ea]">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
              </div>
              <div>
                <p class="fs-5 m-0">Web interface for everyone convenience.</p>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3">
              <div class="me-3 text-[#e710ea]">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
              </div>
              <div>
                <p class="fs-5 m-0">Customized services to meet client needs.</p>
              </div>
            </div>
            <div class="d-flex align-items-center mb-4 mb-xl-5">
              <div class="me-3 text-[#e710ea]">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
              </div>
              <div>
                <p class="fs-5 m-0">24/7 customer support and satisfaction guarantee.</p>
              </div>
            </div>
            <a href='/contact' class="btn bsb-btn-xl outline outline-[1px] outline-[#e710ea] rounded-pill">Connect Now</a>
           </div>
        </div>
      </div>
    </div>
  </div>
</section>


<div class="flex flex-wrap justify-center mt-10">

<div class="p-4 max-w-sm">
        <div class="flex rounded-lg h-full bg-gradient-to-b from-[#e710ea] to-black p-8 flex-col">
            <div class="flex items-center mb-3">
                <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-black text-white flex-shrink-0">
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                </div>
                <Link to="/websitedesigning" className="text-white dark:text-white text-lg font-medium uppercase">
                     website designing
                  
                </Link>
            </div>
            <div class="flex flex-col justify-between flex-grow">
                <p class="leading-relaxed text-base text-white dark:text-gray-300">
                    Get professionally designed websites that enhance your brand’s online presence and functionality.
                </p>
            </div>
        </div>
    </div>
  
    <div class="p-4 max-w-sm">
        <div class="flex rounded-lg h-full  bg-gradient-to-b from-[#e710ea] to-black p-8 flex-col">
            <div class="flex items-center mb-3">
                <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-black text-white flex-shrink-0">
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                </div>
                
                <Link to="/bulksmservice" className="text-white dark:text-white text-lg font-medium uppercase">
                     Bulk SMS Services
                  
                </Link>
            </div>
            <div class="flex flex-col justify-between flex-grow">
                <p class="leading-relaxed text-base text-white dark:text-gray-300">
                    Send thousands of SMS within minutes, including transactional, OTPs, and promotional messages securely and timely.
                </p>
            </div>
        </div>
    </div>

    <div class="p-4 max-w-sm">
        <div class="flex rounded-lg h-full bg-gradient-to-b from-[#e710ea] to-black p-8 flex-col">
            <div class="flex items-center mb-3">
                <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-black text-white flex-shrink-0">
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                </div>
                <Link to="/whatsappservice" className="text-white dark:text-white text-lg font-medium uppercase">
                WhatsApp Services
                  
                </Link>
               
            </div>
            <div class="flex flex-col justify-between flex-grow">
                <p class="leading-relaxed text-base text-white dark:text-gray-300">
                    Reach WhatsApp users easily with our business API facility and engage customers with one-click interactions.
                </p>
            </div>
        </div>
    </div>


    <div class="p-4 max-w-sm">
        <div class="flex rounded-lg h-full bg-gradient-to-b from-[#e710ea] to-black p-8 flex-col">
            <div class="flex items-center mb-3">
                <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full  bg-black text-white flex-shrink-0">
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                </div>
                <Link to="/digitalmarketing" className="text-white dark:text-white text-lg font-medium uppercase">
                Digital Marketing
                  
                </Link>
                
            </div>
            <div class="flex flex-col justify-between flex-grow">
                <p class="leading-relaxed text-base text-white dark:text-gray-300">
                    Maximize your reach through our advanced tools and strategies on social media platforms.
                </p>
            </div>
        </div>
    </div>

   

</div>

<div className='container mt-5'>
  <div className='row justify-content-center'>
    <div className='col-md-10 col-lg-5 mb-4'>
      <div className="card border-0 ">
        <div className="card-body ">
        <h1 class="text-xl md:text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-black to-[#e710ea] uppercase ">Bulk SMS Services</h1>
          <p className="card-text ">
            Bulk SMS Nagpur offers a wide range of SMS services, enabling users to send thousands of SMS in minutes. <br />
            Our platform provides secure and timely delivery of transactional, OTPs, and promotional messages.
          </p>
        </div>
      </div>
      <img src={img2} className="card-img-bottom img-fluid imgTs" alt="Bulk SMS"></img>
    </div>

    <div className='col-md-10 col-lg-7 ps-lg-4'>
      <div className='row g-4'>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36 hover:shadow-lg ">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-chat-left-text d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
  <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
</svg>
              <p className="card-text font-medium">Bulk SMS Services</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-whatsapp d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>
              <p className="card-text font-medium">WhatsApp Services</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-envelope d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
              </svg>
              <p className="card-text font-medium">Email Marketing</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-telephone d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg>
              <p className="card-text font-medium">Voice Call Services</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-lightbulb d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1"/>
</svg>
              <p className="card-text font-medium">Digital Marketing</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-code-slash d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
            <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0"/>
          </svg>
              <p className="card-text font-medium">Website Design & Development</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-gear-wide-connected d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5m0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78zM5.048 3.967l-.087.065zm-.431.355A4.98 4.98 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8zm.344 7.646.087.065z"/>
</svg>
              <p className="card-text font-medium">SEO & SMO Services</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-code-square d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
  <path d="M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0m2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0"/>
</svg>
              <p className="card-text font-medium">Short Code Services</p>
            </div>
          </div>
        </div>

        <div className='col-6 col-md-4 text-center'>
          <div className="card shadow pb-4 border-0 rounded-4 h-36">
            <div className="card-body textsize">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-database d-block mx-auto mb-3 text-[#e710ea]" viewBox="0 0 16 16">
  <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"/>
</svg>
              <p className="card-text font-medium">API Integration Services</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>



      </>
  )
}

export default Home